import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import { parseInlineMarkdown, renderPlainTextWithFormatting } from '../../../../../utils/LearnTab/slideTextRenderer';
import { PointText, SlideTitle } from '../../../../../styles/LearnTab/slideBase.styles';

export const renderTextWithId = (
  id,
  text,
  Component = PointText,
  extraProps = {},
  options = {}
) => {
  if (text == null) return null;

  const { slideEdits = {}, showEnglishContent = false, highlightWord } = options;

  // Normalize text to string when possible
  let normalized = text;
  if (Array.isArray(normalized)) {
    normalized = normalized
      .map(v => (typeof v === 'string' ? v : (v && typeof v === 'object' ? Object.values(v).filter(x => typeof x === 'string').join(' ') : '')))
      .filter(Boolean)
      .join(' ');
  } else if (typeof normalized === 'object') {
    normalized = Object.values(normalized).filter(v => typeof v === 'string').join(' ');
  }
  if (typeof normalized !== 'string') {
    normalized = String(normalized);
  }
  if (!normalized.trim()) return null;

  // Get edit state for this field
  const fieldEdit = slideEdits[id];
  const displayText = showEnglishContent ? (fieldEdit?.original || normalized) : (fieldEdit?.edited || normalized);

  // Check if content contains HTML tags (check both original and edited)
  const hasHtmlTags = /<[^>]+>/.test(normalized) || /<[^>]+>/.test(displayText);

  const contentToRender = displayText;
  if (hasHtmlTags) {
    let sanitized = contentToRender.replace(/<li\s*\/>/gi, '</li>');
    let content = sanitized;
    if (highlightWord) {
      const highlighted = highlightWord(id, sanitized);
      content = typeof highlighted === 'string' ? highlighted : sanitized;
    }

    return (
      <Component
        {...extraProps}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  } else {
    return (
      <Component {...extraProps}>
        {highlightWord ? highlightWord(id, contentToRender) : renderPlainTextWithFormatting(contentToRender)}
      </Component>
    );
  }
};

export const EditableSlideField = ({
  isEditMode = false,
  slide,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  TitleComponent = SlideTitle,
  ContentComponent = PointText,
  titleExtraProps,
  contentExtraProps,
  children,
  ...props
}) => {
  if (isEditMode) {
    return (
      <CombinedEditableSection
        slide={slide}
        isEditMode={isEditMode}
        slideEdits={slideEdits}
        showEnglishContent={showEnglishContent}
        onSave={onSaveEdit}
        onReset={onResetEdit}
        onCancel={onCancelEdit}
        TitleComponent={TitleComponent}
        ContentComponent={ContentComponent}
        titleExtraProps={titleExtraProps}
        contentExtraProps={contentExtraProps}
        {...props}
      />
    );
  }

  return children || null;
};

export { parseInlineMarkdown, renderPlainTextWithFormatting };
export default EditableSlideField;
